import olMap from 'ol/Map';
import OLBaseLayer from 'ol/layer/Base'
import { IBaseLayer } from './IBaseLayer';

export class BaseLayer implements IBaseLayer {

    get ref(): string {
        return this._ref;
    }

    get displayName(): string {
        return this._displayName;
    }

    public get olLayer(): OLBaseLayer {
        return this._layer;
    }

    public constructor(
        protected _ref: string,
        protected _displayName: string,
        protected _layer: OLBaseLayer) {
    }

    public addLayerToMap(map: olMap, visibility: boolean): void {
        this.setVisible(visibility);        
         map.addLayer(this._layer);
    }

    public setVisible(visible: boolean): void {
        return this._layer.setVisible(visible);
    }

    public getVisible(): boolean {
        return this._layer.getVisible();
    }

    public setOpacity(opacity: number): void {
        this._layer.setOpacity(opacity);
    }

}
